/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MainStrategyEnum } from './MainStrategyEnum';
import {
    MainStrategyEnumFromJSON,
    MainStrategyEnumFromJSONTyped,
    MainStrategyEnumToJSON,
    MainStrategyEnumToJSONTyped,
} from './MainStrategyEnum';

/**
 * Event linking configuration for a definition.
 * 
 * ``clean()`` returns warnings as well as errors — informative ones about grouping fields that
 * match no data — so they are surfaced rather than only logged.
 * @export
 * @interface PatchedLinkingRuleRequest
 */
export interface PatchedLinkingRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedLinkingRuleRequest
     */
    workflow?: string;
    /**
     * If set, this rule only applies to events from batches belonging to this data provider. Leave blank for a rule that covers every provider without a rule of its own.
     * @type {string}
     * @memberof PatchedLinkingRuleRequest
     */
    dataProvider?: string | null;
    /**
     * Fields used to group events within a batch, e.g. ["site_id"] or ["site_id", "data_point.data.custom_field"]
     * @type {any}
     * @memberof PatchedLinkingRuleRequest
     */
    groupingFields?: any | null;
    /**
     * Strategy for selecting the main event within a group.
     * 
     * * `oldest` - Oldest created
     * * `direct_match_first` - Direct match preferred
     * * `highest_flux` - Highest flux
     * @type {MainStrategyEnum}
     * @memberof PatchedLinkingRuleRequest
     */
    mainStrategy?: MainStrategyEnum;
}



/**
 * Check if a given object implements the PatchedLinkingRuleRequest interface.
 */
export function instanceOfPatchedLinkingRuleRequest(value: object): value is PatchedLinkingRuleRequest {
    return true;
}

export function PatchedLinkingRuleRequestFromJSON(json: any): PatchedLinkingRuleRequest {
    return PatchedLinkingRuleRequestFromJSONTyped(json, false);
}

export function PatchedLinkingRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedLinkingRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflow': json['workflow'] == null ? undefined : json['workflow'],
        'dataProvider': json['data_provider'] === undefined ? undefined : json['data_provider'] === null ? null : json['data_provider'],
        'groupingFields': json['grouping_fields'] === undefined ? undefined : json['grouping_fields'] === null ? null : json['grouping_fields'],
        'mainStrategy': json['main_strategy'] == null ? undefined : MainStrategyEnumFromJSON(json['main_strategy']),
    };
}

export function PatchedLinkingRuleRequestToJSON(json: any): PatchedLinkingRuleRequest {
    return PatchedLinkingRuleRequestToJSONTyped(json, false);
}

export function PatchedLinkingRuleRequestToJSONTyped(value?: PatchedLinkingRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflow': value['workflow'],
        'data_provider': value['dataProvider'],
        'grouping_fields': value['groupingFields'],
        'main_strategy': MainStrategyEnumToJSON(value['mainStrategy']),
    };
}

